<div class="container-fluid h-100">
	<div class="row h-100">
		<div class="col-12">
			<div class="d-flex align-items-center justify-content-center h-100">
				<div class="col-4">
					<h5>Integrations</h5>
					<div class="card">
						<div class="card-body">
							<div class="form">
								<div class="mb-3">
									<label for="selectIntegration" class="form-label fw-bold">Select Integration:</label>
									<select class="form-select"
										id="selectIntegration"
										[(ngModel)]="integration">
										<option [value]="null" disabled selected>Select one</option>
										<option [value]="item.integrationId" *ngFor="let item of integrations; index as i">{{item.integrationName}}</option>
									</select>
								</div>
								<div class="text-end">
									<button
										type="button"
										class="btn btn-primary px-5"
										(click)="goTo()"
										[disabled]="!integration"
									>
											Select
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
